import GoogleMapsLoader from 'google-maps';

import styles from './styles.json';

export default class BrixMap {
  static init(...parameters) {
    return new BrixMap(...parameters);
  }

  constructor(block) {
    this.block = block;
    this.tabletMode = false;

    // Check if state has changed otherwise do not change map options and position.
    this.isParentTablet = null;

    // Map center point has two states
    this.mapCenterPoint = null;
    this.onReady();
  }

  onReady() {
    this.mapContainer = this.block.querySelector('.map');
    this.initMap();
  }

  initMap() {
    GoogleMapsLoader.KEY = this.mapContainer.dataset.key;
    GoogleMapsLoader.load((google) => this.mapLoaded(google));
  }

  mapLoaded(google) {
    this.google = google;
    const mapWrapper = this.mapContainer;
    const latF = parseFloat(this.mapContainer.dataset.lat);
    const lngF = parseFloat(this.mapContainer.dataset.lng);
    const zoomInt = parseInt(this.mapContainer.dataset.zoom, 10);
    // const pinColor = this.convertHex(this.container.dataset.pincolor, 1);
    // Avoid svg – will not show in IE 11. Use base64 encoded png.
    const markerIcon = {
      url: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAYFBMVEUAAAD77mX372j/72j772b77Wb67mb77mb67GX57Wb77mf/73D/72D77mb872b87mb67WX77Wb87Gb77mX662f67Wf87Wf672X67Gb872f872n87GP57mf67Wb67Gj77mYi5MdbAAAAH3RSTlMA7yAgf4Dfz2CAvxAQ71/fkK9Qv5CQn2Cgn19QsKBgaqSwhgAAAO9JREFUeF6V1NmuwyAQA1APSYCSrUnbuy7+/7+8L0hRRZLi8zyWZ4QECv37ffFG0qf71OCFvr3xSTjN9K2x9HYYyeOlFntc4KF5p+TLeGJci3X4QlvMS4mVFaYt4IwVxu1yzyqh/oDskhdirXEAAHyQUoUjtYpIahWBggQ4SgZESiKulFyRKPmBp2QGNSMo0gNGjX70QknSHy5SMmGgpAESBQHARdsIGEzaSKv4BLSKBpAqOmSBVWbxM7YGWeXftGKDTjggJ8R54Nt4wv5QcJ6HQoOsai3rcMD97o73OOZi4JNbOV5mHsmTNL88Yjn9D5Hb1z2DXq+eAAAAAElFTkSuQmCC',
      scaledSize: new google.maps.Size(24, 24), // Scaled size of marker image
      anchor: new google.maps.Point(12, 12), // Centers acnhor point
    };

    const options = {
      zoom: zoomInt,
      center: { lat: latF, lng: lngF },
      mapTypeControl: false,
      scrollwheel: false,
      streetViewControl: false,
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.ROADMAP,
        mapTypeIds: ['roadmap', 'terrain'],
      },
      styles,
    };
    this.map = new google.maps.Map(mapWrapper, options);

    this.marker = new google.maps.Marker({
      position: { lat: latF, lng: lngF },
      map: this.map,
      icon: markerIcon,
      optimized: false,
    });
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-map', BrixMap.init);
}
